import React from 'react';
import PhotoGallery from './RotatingGallery';

import photo1 from '../img/photo_chicago.jpeg';
import photo2 from '../img/IMG20230810175501.jpg';
import photo3 from '../img/IMG20230811172514.jpg';
import photo4 from '../img/IMG20240226164202.jpg';
import photo5 from '../img/9.9.jpeg';
import photo6 from '../img/IMG_20151229_203836.jpg';
import photo7 from '../img/IMG_20151226_141357.jpg';
import photo8 from '../img/IMG_20230526_183626.jpg';
import photo9 from '../img/IMG20230806154627.jpg';
import photo10 from '../img/IMG_20170510_190710.jpg';
import photo11 from '../img/IMG_20180101_002418.jpg';
import photo12 from '../img/IMG_20230708_172910.jpg';
import photo13 from '../img/IMG-20181028-WA0005.jpg';

const RevealGrid: React.FC = () => {
  return (
    <PhotoGallery
      photos={[
        photo1,
        photo2,
        photo3,
        photo4,
        photo5,
        photo6,
        photo7,
        photo8,
        photo9,
        photo10,
        photo11,
        photo12,
        photo13,
      ]}
    />
  );
};

export default RevealGrid;
